// WESTBRIDGE
//
//
//
//
//
//
export function initQuantrefy() {


  /////////////////////////////////////////////////
  // GRIDANIMATIONS Klient: QUANTREFY (GSAP)
  //////////////////////////////////////////////////

  if (document.querySelectorAll('.grid-card-quantrefy').length > 0) {

    // Batch animation for grid cards with performance optimization
    ScrollTrigger.batch('.grid-card-quantrefy', {
      interval: 0.1, // Slight stagger between card animations
      batchMax: 3, // Limit simultaneous animations
      start: "top 85%",
      end: "bottom 15%",
      onEnter: batch => {
        gsap.to(batch, {
          autoAlpha: 1,
          y: 0,
          stagger: {
            each: 0.15, // Smooth, quick stagger
            from: "start", // Stagger from the start of the batch
            ease: "power2.out"
          },
          duration: 0.8,
          ease: "power2.out"
        });

        // Animate icons with a slightly delayed, subtle effect
        batch.forEach(frame => {
          const icon = frame.querySelector('.grid-card-quantrefy-shout-icon');
          if (icon) {
            gsap.fromTo(icon, 
              { 
                y: 30, 
                autoAlpha: 0 
              }, 
              {
                y: 0,
                autoAlpha: 1,
                duration: 0.6,
                delay: 0.2,
                ease: "power1.out"
              }
            );
          }
        });
      },
      onLeaveBack: batch => {
        gsap.to(batch, {
          autoAlpha: 0,
          y: 30,
          stagger: {
            each: 0.1,
            from: "end", // Reverse stagger when scrolling back
            ease: "power2.in"
          },
          duration: 0.5,
          ease: "power2.in"
        });

        // Reverse icon animations
        batch.forEach(frame => {
          const icon = frame.querySelector('.grid-card-quantrefy-shout-icon');
          if (icon) {
            gsap.to(icon, {
              y: 30,
              autoAlpha: 0,
              duration: 0.4,
              ease: "power1.in"
            });
          }
        });
      }
    });

    const resizeObserver = new ResizeObserver(() => {
      if (window.innerWidth > 768) {
        ScrollTrigger.refresh();
      }
    });
    
    // Attach observer to <html> or <body>
    resizeObserver.observe(document.documentElement);

  }

  ////////////// hovers

  // Only initialize hover effects if grid cards exist
  if (document.querySelectorAll('.grid-card-quantrefy').length > 0) {
    // Select all the grid cards
    const cards = document.querySelectorAll('.grid-card-quantrefy');

    cards.forEach(card => {
      const shoutbox = card.querySelector('.grid-card-quantrefy-shout-icon');
      const asset = card.querySelector(".gridcardquantrefyasset");

      // Consolidated hover events to reduce redundancy
      asset.addEventListener("mouseenter", () => {
        // Scale the asset (background element) slightly up
        gsap.to(asset, {
          y: -5,
          duration: 0.25,
          ease: "power3.out"
        });

        // Scale the shoutbox up with a slight delay for better visual flow
        if (shoutbox) {
          gsap.to(shoutbox, {
            scale: 1.09,
            duration: 0.3,
            delay: 0.3,  // Small delay to create a smooth visual order
            ease: "power1.out"
          });
        }
      });

      asset.addEventListener("mouseleave", () => {
        // Reset the scale of the asset
        gsap.to(asset, {
          y: 0,
          duration: 0.6,
          ease: "power2.inOut"
        });

        // Reset the scale of the shoutbox with delay
        if (shoutbox) {
          gsap.to(shoutbox, {
            scale: 1,
            duration: 1,
            ease: "power2.inOut"
          });
        }
      });
    });
  }
    


    // END OF MODULE
    console.log("Quantrefy-Grid initialized");
}